var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-outline-light float-left text-dark",on:{"click":function($event){return _vm.routeBack()}}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" Back\n")]),_c('div',{attrs:{"id":"swagger-ui"}})])}
var staticRenderFns = []

export { render, staticRenderFns }